import React, { useState, useEffect } from 'react'
import { AnimatePresence, m, LazyMotion, domAnimation } from 'framer-motion'
import { Capacitor } from '@capacitor/core'

export function CookieConsent() {
  const [show, setShow] = useState(false)

  useEffect(() => {
    // Native iOS/Android'de web çerez banner'ı gösterilmez
    if (Capacitor.isNativePlatform()) return

    const consent = localStorage.getItem('cookie_consent_status')
    if (!consent) {
      const timer = setTimeout(() => setShow(true), 1500) // Hafif gecikmeli UX
      return () => clearTimeout(timer)
    }
  }, [])

  if (Capacitor.isNativePlatform()) return null

  const handleAccept = () => {
    localStorage.setItem('cookie_consent_status', 'accepted')
    setShow(false)
  }

  const handleReject = () => {
    localStorage.setItem('cookie_consent_status', 'rejected')
    setShow(false)
  }

  return (
    <LazyMotion features={domAnimation}>
      <AnimatePresence>
        {show && (
          <m.div
            initial={{ y: 200, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 200, opacity: 0 }}
            transition={{ type: 'spring', stiffness: 280, damping: 25 }}
            className="fixed bottom-0 left-0 right-0 z-[9999] p-4 sm:p-6 pointer-events-none flex justify-center"
          >
            <div className="bg-[#1e2329] text-white rounded-2xl p-5 sm:px-6 shadow-2xl max-w-4xl w-full pointer-events-auto border border-white/10 flex flex-col md:flex-row items-start md:items-center justify-between gap-5">
              
              <div className="flex-1 space-y-1">
                <h3 className="font-bold text-[14px] flex items-center gap-2">
                  <span aria-hidden="true">🍪</span> Çerez ve Gizlilik Tercihleri
                </h3>
                <p className="text-[12px] text-gray-300 leading-relaxed font-medium">
                  Sitemiz, size daha iyi ve kişiselleştirilmiş bir deneyim sunabilmek amacıyla 
                  <a href="/kvkk" target="_blank" rel="noreferrer" className="text-white underline mx-1 hover:text-[#D4AF37] transition-colors">
                    KVKK
                  </a>
                  ve
                  <a href="/gizlilik" target="_blank" rel="noreferrer" className="text-white underline mx-1 hover:text-[#D4AF37] transition-colors">
                    Gizlilik Politikası
                  </a>
                  standartlarına uygun olarak çerezler kullanmaktadır.
                </p>
              </div>

              <div className="flex items-center gap-2.5 w-full md:w-auto">
                <button
                  onClick={handleReject}
                  className="flex-1 md:flex-none px-4 py-2.5 rounded-xl border border-gray-600/50 text-[12px] font-bold text-gray-300 hover:bg-white/5 transition-colors focus-visible:ring-2 focus-visible:ring-gray-400 focus-visible:outline-none"
                >
                  Sadece Zorunlu
                </button>
                <button
                  onClick={handleAccept}
                  className="flex-1 md:flex-none px-5 py-2.5 rounded-xl bg-white text-black text-[12px] font-extrabold shadow-md hover:bg-gray-100 active:scale-95 transition-transform focus-visible:ring-2 focus-visible:ring-white focus-visible:outline-none"
                >
                  Tümünü Kabul Et
                </button>
              </div>

            </div>
          </m.div>
        )}
      </AnimatePresence>
    </LazyMotion>
  )
}
